import React, { useState } from 'react';
import { MatchTimeControls } from './MatchTimeControls';

export const MatchTimeControlsTest = () => {
  const [clock, setClock] = useState({
    minute: 45,
    second: 23,
    running: false,
    half: 1,
    injuryTime: 2
  });
  const [joined, setJoined] = useState(true);

  const handleStartClock = () => {
    console.log('Start clock');
    setClock({ ...clock, running: true });
  };

  const handleStopClock = () => {
    console.log('Stop clock');
    setClock({ ...clock, running: false });
  };

  const handleResetClock = (half) => {
    console.log('Reset clock for half:', half);
    setClock({ ...clock, minute: 0, second: 0, running: false });
  };

  const handleSetTime = (minute, second) => {
    console.log('Set time:', minute, second);
    setClock({ ...clock, minute, second });
  };

  const handleSetInjuryTime = (minutes) => {
    console.log('Set injury time:', minutes);
    setClock({ ...clock, injuryTime: minutes });
  };

  const handleChangeHalf = (halfNumber) => {
    console.log('Change half:', halfNumber);
    setClock({ ...clock, half: halfNumber, minute: 0, second: 0, injuryTime: 0 });
  };

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-2xl font-bold mb-4">MatchTimeControls Test</h1>
        
        {/* Test Controls */}
        <div className="bg-white p-4 rounded-lg shadow mb-4">
          <h2 className="font-semibold mb-2">Test Controls</h2>
          <div className="flex gap-4 flex-wrap">
            <button
              onClick={() => setClock({ ...clock, minute: clock.minute + 1 })}
              className="px-3 py-1 bg-blue-600 text-white rounded"
            >
              +1 Minute
            </button>
            <button
              onClick={() => setClock({ ...clock, second: clock.second + 10 })}
              className="px-3 py-1 bg-blue-600 text-white rounded"
            >
              +10 Seconds
            </button>
            <button
              onClick={() => setJoined(!joined)}
              className={`px-3 py-1 rounded text-white ${joined ? 'bg-green-600' : 'bg-red-600'}`}
            >
              {joined ? 'Disconnect' : 'Connect'}
            </button>
            <button
              onClick={() => setClock({ ...clock, minute: 90, injuryTime: 5 })}
              className="px-3 py-1 bg-purple-600 text-white rounded"
            >
              90th Minute +5
            </button>
          </div>
          <div className="mt-2 text-sm text-gray-600">
            State: {clock.minute}:{String(clock.second).padStart(2, '0')} | 
            Half: {clock.half} | 
            Running: {clock.running ? 'Yes' : 'No'} | 
            Injury: +{clock.injuryTime}
          </div>
        </div>

        {/* Component Under Test */}
        <MatchTimeControls
          clock={clock}
          onStartClock={handleStartClock}
          onStopClock={handleStopClock}
          onResetClock={handleResetClock}
          onSetTime={handleSetTime}
          onSetInjuryTime={handleSetInjuryTime}
          onChangeHalf={handleChangeHalf}
          joined={joined}
        />
      </div>
    </div>
  );
};
